import {
  bundleIcon,
  DocumentLockFilled,
  DocumentLockRegular,
  DocumentOnePageFilled,
  DocumentOnePageRegular,
} from "@fluentui/react-icons";

export const PrivacyIcon = bundleIcon(DocumentLockFilled, DocumentLockRegular);
export const TermsIcon = bundleIcon(DocumentOnePageFilled, DocumentOnePageRegular);
